// REACT IMPORTS
import React, { useState, useEffect } from "react";

// CONTROLS IMPORTS
import { yupResolver } from '@hookform/resolvers/yup';
// import * as yup from 'yup';
import {useYupSchema} from '../../components/util/hookYupSchema'
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { esES, enUS } from '@mui/x-data-grid/locales';
import { Box, TextField, Menu, MenuItem, Divider, IconButton, Grid,
    FormControl, InputLabel, Select, Typography, Button, Checkbox,
    Dialog, DialogContent, DialogContentText, DialogActions, DialogTitle,
    TextareaAutosize, FormHelperText
 } from '@mui/material';
import { useForm, Controller } from 'react-hook-form';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'; 

// ICONS IMPORTS
import AddCommentIcon from '@mui/icons-material/AddComment';

// REDUX IMPORTS
import { useDispatch, useSelector } from 'react-redux';
import { loadContactQuestions } from '../../store/thunks';
import { selectItemById, showResponseContactQuestionModal } from '../../store/slices';

// LANGUAGE IMPORTS
import { useTranslation } from 'react-i18next';

// OWNED COMPONENTS IMPORTS
import { constants } from  '../../util'
import BodyMain from "../../components/util/BodyMain";
import { responseContactQuestions } from "../../store/thunks/contactQuestionsThunk";


const ContactQuestions = () => {
    // TRANSLATIONS
    const [t, i18n] = useTranslation("global");
  
  
    // LOCAL VARIABLES
    const columsGrid = 
    [
        {
            field: 'name',
            description: t("contactQuestions.user"),
            headerName: t("contactQuestions.user"),
            type: 'string',
            width:180,
            headerAlign: 'left',
        },
        {
            field: 'question',
            description: t("contactQuestions.question"),
            headerName: t("contactQuestions.question"),
            type: 'string',
            width: 400,
            headerAlign: 'left',
            renderCell: (params) => (
              <div style={{
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  gap: '4px',
                  padding: '8px 0',
              }}>
                  <div style={{ 
                      color: '#667', 
                      fontSize: '0.8rem',
                      lineHeight: '1.2',
                      wordWrap: 'break-word',
                  }}>
                      <b>{ language==='es' ? 'Pregunta = ' : 'Question = '}</b>{params.value}
                  </div>
                  <div style={{ 
                      color: '#667', 
                      fontSize: '0.8rem',
                      lineHeight: '1.2',
                      wordWrap: 'break-word',
                  }}>
                      <b>{ language==='es' ? 'Respuesta = ' : 'Answer = '}</b>{params.row.answer}
                  </div>
              </div>
            )
        },
        {
            field: 'date',
            description: t("contactQuestions.date"),
            headerName: t("contactQuestions.date"),
            type: 'string',
            width: 120,
            headerAlign: 'left',
        },
        {
            field: 'statusName',
            description: t("contactQuestions.status"),
            headerName: t("contactQuestions.status"),
            type: 'string',
            width: 120,
            headerAlign: 'left',
            renderCell: (params) => (
                <div style={{width:'100%', height:'100%', display:'flex', justifyContent:'center', alignItems:'center'}}>
                    <div style={{
                        backgroundColor: params.row.statusColor==='yellow' ? '#FFFB95' : ( params.row.statusColor==='green' ? '#95FFA6' : ( params.row.statusColor==='blue' ? '#DDE6FF' : '#FFC7C7')),
                        border: params.row.statusColor==='yellow' ? '1px solid #CBA600' : ( params.row.statusColor==='green' ? '1px solid #009C17' : ( params.row.statusColor==='blue' ? '1px solid #0136BD' : '1px solid #C00000')),
                        width:'90%',
                        height:'30px',
                        display:'flex',
                        justifyContent:'center',
                        alignContent:'center',
                        alignItems:'center',
                        borderRadius:'7px',
                        color: '#667', 
                        fontSize: '0.7rem',
                        fontWeight: 'bold',
                    }}>
                        {
                            language==='es' && params.value==='Pending' 
                                ? "Pendiente"
                                : language==='es' && params.value==='Responsed' 
                                    ? "Respondida"
                                    : language==='en' && params.value==="Pendiente" 
                                        ? "Pending"
                                        : language==='en' && params.value==='Respondida' 
                                            ? "Responsed"
                                            : params.value
                        }
                    </div>
                </div>
            )
        },
        {
            field: 'contactId',
            description: t("contactQuestions.response"),
            headerName: t("contactQuestions.response"),
            type: 'string',
            width: 120,
            headerAlign: 'left',
            renderCell: (params) => {
                return (
                    <div style={{width:'100%', height:'100%', justifyContent:'center', alignContent:'center',
                                display: params.row.status ? 'none' : 'flex'
                    }}>
                        <IconButton 
                            color="primary"
                            onClick={() => handleClick_Response(params.value)}
                            aria-label="Response"
                            sx={{display:'flex', flexDirection:'column'}}
                        >
                          <AddCommentIcon fontSize="large" />
                          <div style={{width:'100%', textAlign:'center', color: '#667', fontSize: '0.8rem'}}>{t("contactQuestions.response")}</div>
                        </IconButton>
                    </div>
                );
            }
        },
    ];


    const sch = (yup) => yup.object({
        startDate: yup.string().required(),
        endDate: yup.string().required(),
        question: yup.string().max(30),
        status: yup.string().max(20),
    });
    const schema = useYupSchema(sch);

    const sch2 = (yup) => yup.object({
        answer: yup.string().required().max(150),
    });
    const schemaResponseQuestion = useYupSchema(sch2);

    const { control, register, handleSubmit, reset, setFocus, getValues, setValue, formState: { errors: errors } } = useForm({
            resolver: yupResolver(schema),
            defaultValues: {
                startDate: dayjs().subtract(1, 'month').toISOString(),
                endDate: dayjs().toISOString(),
                question: '',
                status: '-1'
            }
        });
    
    const { control: controlResponseQuestion, register: registerResponseQuestion, handleSubmit: handleSubmitResponseQuestion, reset: resetResponseQuestion, formState: { errors: errorsResponseQuestion } } = useForm({
            resolver: yupResolver(schemaResponseQuestion),
            defaultValues: {
                answer: '',
            }
        });

    
    // LOCAL STATES
    
    // NEEDED HOOKS
    const dispatch = useDispatch();
    const { itemsContactQuestions, selectedId, selectedItem, openResponseContactQuestion } = useSelector(state => state.contactQuestions);
    const { language } = useSelector(state => state.configuration);

    // EFFECTS
    useEffect(() => {
        dispatch(
            loadContactQuestions
            (
                {
                    startDate: dayjs().subtract(1, 'month').toISOString(),
                    endDate: dayjs().toISOString(),
                    question: '',
                    status: '-1'
                }
            )
        )
    }, [])

    // LOCAL FUNCTIONS
    const onSubmit = (data) => {
      dispatch(
            loadContactQuestions
            (
                {
                    startDate: data.startDate,
                    endDate: data.endDate,
                    question: data.question,
                    status: data.status.toString()
                }
            )
        )
    }
    
    const handleClick_Response = (id) => {
        dispatch(selectItemById(id));
        dispatch(showResponseContactQuestionModal(true));
        resetResponseQuestion();
    }

    const handleClose = () => {
        resetResponseQuestion();
        dispatch(showResponseContactQuestionModal(false));
    }

    const submitResponse = (data) => {
        dispatch(
            responseContactQuestions({
                contactId: selectedId.toString(),
                answer: data.answer
            })
        )
    }


    return (
        <BodyMain>
            <h2 style={{color:'#667'}}>{t("contactQuestions.title")}</h2>
            <form onSubmit={handleSubmit(onSubmit)}
                style={{
                    width:'100%',
                    height:'100%',
                    display:'flex',
                    flexDirection:'column',
                    marginBottom:'50px'
                }}
            >
                <Grid container spacing={2} direction="row" size={12}>
                    <Grid container direction="row" size={12}>
                        <Grid size={6}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={['DatePicker']}>
                                    <Controller
                                        name="startDate"
                                        control={control}
                                        render={({ field, fieldState: { error } }) => (
                                            <DatePicker
                                                label={t("contactQuestions.startDate")}
                                                format="DD/MM/YYYY"
                                                value={field.value ? dayjs(field.value) : null}
                                                onChange={(date) => field.onChange(date)}
                                                slotProps={{
                                                    textField: {
                                                        error: !!error,
                                                        helperText: error?.message,
                                                        margin: 'normal',
                                                    },
                                                }}
                                            />
                                        )}
                                    />
                                </DemoContainer>
                            </LocalizationProvider>
                        </Grid>
                        <Grid size={6}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={['DatePicker']}>
                                    <Controller
                                        name="endDate"
                                        control={control}
                                        render={({ field, fieldState: { error } }) => (
                                            <DatePicker
                                            label={t("contactQuestions.endDate")}
                                            format="DD/MM/YYYY"
                                            value={field.value ? dayjs(field.value) : null}
                                            onChange={(date) => field.onChange(date)}
                                            slotProps={{
                                                textField: {
                                                error: !!error,
                                                helperText: error?.message,
                                                },
                                            }}
                                            />
                                        )}
                                    />
                                </DemoContainer>
                            </LocalizationProvider>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} direction="row" size={12}>
                        <Grid size={6} sx={{paddingTop:'8px'}}>
                            <TextField label={t("contactQuestions.question")} variant="outlined" margin="normal" fullWidth sx={{...constants.styles.textfield}} 
                                {...register('question')}
                                error={!!errors.question}
                                helperText={errors.question?.message}
                            />
                        </Grid>
                        <Grid size={6} sx={{paddingTop:'8px'}}>
                            <Controller
                                name="status"
                                control={control}
                                render={({ field }) => (
                                <FormControl fullWidth error={!!errors.statusId}>
                                    <InputLabel id="status-label">{t("contactQuestions.status")}</InputLabel>
                                    <Select
                                        {...field}
                                        labelId="status-label"
                                        label={t("contactQuestions.filterStatus")}
                                        sx={{ width: '100%' }}
                                    >
                                        <MenuItem value={-1}>
                                            <Typography>{ language==='es' ? 'Todos los estatus' : 'All status'}</Typography>
                                        </MenuItem>
                                        <MenuItem value={1}>
                                            <Typography>{ language==='es' ? 'Respondida' : 'Responsed'}</Typography>
                                        </MenuItem>
                                        <MenuItem value={0}>
                                            <Typography>{ language==='es' ? 'Pendiente' : 'Pending'}</Typography>
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                                )}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} direction="row" size={12}>
                        <Grid size={6} sx={{paddingTop:'8px'}}>
                            <Button
                                type="submit"
                                variant="outlined"
                                sx={{ ...constants.styles.mainButton, height:'55px', width:'auto-fit', paddingLeft:'80px', paddingRight:'80px' }}
                            >
                                {t("contactQuestions.search")}
                            </Button>
                        </Grid>
                        <Grid size={6}>
                            
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} direction="row" size={12}>
                        
                    </Grid>
                </Grid>
            </form>
            <Box sx={{ 
                width: '100%',
                '& .alternateClass': {
                    backgroundColor: '#f2f2f2',
                    borderTop: '1px solid #e8e8e8',
                },
                '& .rowClass': {
                    borderTop: '1px solid #e8e8e8',
                },
                '& .alternateClass:hover': {
                    backgroundColor: '#999c9e',
                },
                '& .rowClass:hover': {
                    backgroundColor: '#999c9e',
                },
            }}>
                <DataGrid
                    getRowId={(row) => row.contactId}
                    getRowHeight={() => 100}
                    rows={itemsContactQuestions || []}
                    columns={columsGrid}
                    initialState={{
                        pagination: {
                            paginationModel: {
                                pageSize: 10,
                            },
                        },
                        density: 'compact',
                    }}
                    getRowClassName ={
                        (params) =>
                            params.indexRelativeToCurrentPage % 2 === 0 ? 'alternateClass' : 'rowClass'
                    }
                    pageSizeOptions={[5,10,20,{value:-1, label:language==='es' ? 'Todo' : 'All'}]}
                    checkboxSelection = {false}
                    disableRowSelectionOnClick
                    disableColumnMenu
                    slots={{
                        toolbar: GridToolbar,
                    }}
                    slotProps={{
                        toolbar: {
                            showQuickFilter: true,
                        }
                    }}
                    localeText={
                        language === 'es' 
                        ? esES.components.MuiDataGrid.defaultProps.localeText
                        : enUS.components.MuiDataGrid.defaultProps.localeText
                    }
                    sx={{
                        '& .MuiDataGrid-cell, .MuiDataGrid-columnHeader': {
                            color: '#667', 
                            fontSize: '0.8rem',
                        },
                        '& .MuiDataGrid-cell': {
                            // Estos estilos son importantes para mostrar el contenido completo
                            overflow: 'visible !important',
                            whiteSpace: 'normal !important',
                            alignItems: 'flex-start', // Alinear contenido al inicio
                            padding: '8px', // Espaciado interno
                        },
                        '& .MuiDataGrid-row': {
                            maxHeight: 'none !important', // Permitir que la fila crezca
                        },
                    }}
                />
            </Box>
            <br />

            <Dialog open={openResponseContactQuestion} onClose={handleClose}>
                <DialogTitle>{t("contactQuestions.response-title")}</DialogTitle>
                <form onSubmit={handleSubmitResponseQuestion(submitResponse)}>
                    <DialogContent style={{maxWidth:'400px'}}>
                        <DialogContentText>
                            <b>{`${selectedItem?.name}: `}</b>{`${selectedItem?.question}`}
                        </DialogContentText>
                        <br />
                        <Controller
                            name="answer"
                            control={controlResponseQuestion}
                            render={({ field }) => (
                                <FormControl fullWidth error={!!errorsResponseQuestion.answer}>
                                    <TextareaAutosize
                                        {...field}
                                        minRows={10}
                                        maxRows={10}
                                        placeholder={t("contactQuestions.response-placeholder")}
                                        style={{ width: '350px' }}
                                    />
                                    {errorsResponseQuestion?.answer && (
                                        <FormHelperText error>
                                            {errorsResponseQuestion.answer.message}
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            )}
                        />
                    </DialogContent>
                    <DialogActions>
                        {/* <Button onClick={handleClose}>Cancelar</Button> */}
                        <Button type="submit" variant="contained"
                            sx={{ ...constants.styles.mainButton, height:'35px', width:'auto-fit', paddingLeft:'40px', paddingRight:'40px', marginRight:'15px', marginBottom:'15px' }}>
                            {t("contactQuestions.response-btnResponse")}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </BodyMain>
    )
}

export default ContactQuestions